import React, { Fragment, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useQuery from '../../hooks/useQuery';
import { Form, Card, Button, Row, Col, Table, Badge} from 'react-bootstrap';
import Pagination from '../../components/Nav/Pagination';
import { formatComma } from '../../helpers/helpers';
import config from '../../config';
import axios from 'axios';
import Cookies from 'js-cookie';
import Colors from '../../constants/Colors';
import Swal from 'sweetalert2'

const AffiliateTransferToggle = () => {
  const query = useQuery();
  const dispatch = useDispatch();
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [userNo, setUserNo] = useState('');
  const [limit, setLimit] = useState(20);
  const [forceUpdate, setForceUpdate] = useState(false);

  useEffect(() => {
    fetchAffiliateUsers();
  }, [forceUpdate, currentPage]);

  const fetchAffiliateUsers = async (_query = {}) => {
    try {
      dispatch({ type: 'loading_show' });
      const query = { ..._query, userNo, page: currentPage, limit };
      const res = await axios.get(`${config.apiAdminGateway}/api/v1/admin/affiliates`, {
        params: query,
        headers: { Authorization: `Bearer ${Cookies.get('accessToken')}` },
      });
      const { status: { code, description }, data } = res.data;
      if (code !== 0) throw new Error(description);
      setUsers(data);
    } catch (error) {
      setUsers([]);
    } finally {
      dispatch({ type: 'loading_hide' });
    }
  };

  const postAutoTransfer = async (userId, autoTransferStatus) => {
    try {
      dispatch({ type: 'loading_show' });
      const body = { userId, autoTransfer: !autoTransferStatus };
      const res = await axios.post(`${config.apiAdminGateway}/api/v1/admin/affiliates/auto-transfer`, body, {
        headers: { Authorization: `Bearer ${Cookies.get('accessToken')}` },
      });
      const { status: { code, description } } = res.data;
      if (code !== 0) {

        let message;
        switch (code) {
            case 1002:
                message = 'ผู้ใช้งานยังไม่ผ่านขั้นตอน KYC';
                break;
            case 2013:
                message = 'ผู้ใช้งานถูกระงับการให้บริการ';
                break;
            default:
                message = description;
        }
        
        Swal.fire({
          title: 'เกิดข้อผิดพลาดในการปรับสถานะ',
          text: message,
          icon: 'error',
        })
      } else {
        Swal.fire({
          title: `ปรับสถานะการถอนอัตโนมัติผู้ใช้ ${userNo} สำเร็จ`,
          text: `สถานะ : ${autoTransferStatus ? 'เปิด': 'ปิด'} -> ${!autoTransferStatus ? 'เปิด': 'ปิด'}`,
          icon: 'success',
        })

      }
    } catch (error) {
      setUsers([]);
    } finally {
      dispatch({ type: 'loading_hide' });
      setForceUpdate(prevState => !prevState);
    }
  };

  const onChangePage = page => {
    setCurrentPage(page);
    fetchAffiliateUsers({ page });
  };

  const onChangeTransfer = (userNo, userId, autoTransferStatus) => {
    postAutoTransfer(userId, autoTransferStatus).then(() => {
      setUserNo(userNo);
      setCurrentPage(1);
      fetchAffiliateUsers({ userNo, page: 1 });
    });
  };

  const displaySearch = () => (
    <Form>
      <Form.Group>
        <Row>
          <Col sm={12} md={8} lg={4}>
            <input
              className="form-control"
              style={{ color: Colors.DARK_GREY }}
              type="text"
              placeholder="รหัสลูกค้า"
              onChange={e => setUserNo(e.target.value.toUpperCase().trim())}
              value={userNo}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  e.preventDefault()
                  setCurrentPage(1);
                  fetchAffiliateUsers({ userNo, page: 1 });
                }
              }}
            />
          </Col>
          <Col sm={12} md={12} lg={4}>
            <Row>
              <Col md={6} lg={0}></Col>
              <Col md={6} lg={12}>
                <Button
                  variant="danger light"
                  className="w-50"
                  onClick={() => {
                    setUserNo('');
                    setForceUpdate(prevState => !prevState);
                  }}
                >
                  ล้างตัวกรอง
                </Button>
                <Button
                  variant="primary light"
                  className="w-50"
                  onClick={() => {
                    setCurrentPage(1);
                    fetchAffiliateUsers({ userNo, page: 1 });
                  }}
                >
                  ค้นหา
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form.Group>
    </Form>
  );

  const displayTableUser = () => (
    <Table responsive striped bordered className="verticle-middle">
      <thead>
        <tr>
          <th>รหัสลูกค้า</th>
          <th>จำนวนเงิน</th>
          <th>จำนวนเงินทั้งหมด</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {users.map((list, i) => (
          <tr key={i}>
            <td>{list.user.userNo}</td>
            <td>{formatComma(list.amount)} บาท</td>
            <td>{formatComma(list.totalAmount)} บาท</td>
            <td>
              <Badge variant={list.autoTransfer ? 'success light' : 'danger light'}>
                {list.autoTransfer ? 'เปิด' : 'ปิด'}
              </Badge>
            </td>
            <td>
              <Badge variant="info" style={{ cursor: 'pointer' }} onClick={() => onChangeTransfer(list.user.userNo, list.user.userId, list.autoTransfer)}>
                ปรับสถานะเปิดปิดการถอนอัตโนมัติ - {list.autoTransfer ? 'ปิด' : 'เปิด'}
              </Badge>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );

  return (
    <Fragment>
      <Card>
        <Card.Body>
          {displaySearch()}
          {displayTableUser()}
          <Pagination
            currentPage={currentPage}
            onPrevPage={() => onChangePage(currentPage - 1)}
            onNextPage={() => onChangePage(currentPage + 1)}
            items={users}
            perPage={20}
          />
        </Card.Body>
      </Card>
    </Fragment>
  );
};

export default AffiliateTransferToggle;
